import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AutoBIMLogo, Wordmark } from "@/components/Brand";

export default function Terms() {
  const { lang } = useAuth();
  const isAr = lang === "ar";
  return (
    <div className="min-h-screen abl-grid-bg">
      <header className="flex items-center justify-between border-b border-border bg-background/85 px-5 py-3 backdrop-blur">
        <Link to="/landing" className="flex items-center gap-2.5"><AutoBIMLogo size={30} /><Wordmark small /></Link>
      </header>
      <div className="mx-auto max-w-3xl px-5 py-10">
        <h1 className="mb-6 text-2xl font-black">{isAr ? "الشروط والأحكام" : "Terms of Service"}</h1>
        <div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
          <p>{isAr ? "AutoBIM Logic أداة مساعدة لتوليد المخططات المعمارية والإنشائية. المخرجات يجب أن يراجعها ويعتمدها مهندس مرخّص قبل التنفيذ أو التقديم للجهات الرسمية." : "AutoBIM Logic is an assistive tool for generating architectural and structural plans. All outputs must be reviewed and stamped by a licensed engineer before construction or submission to authorities."}</p>
          <p>{isAr ? "أنت مسؤول عن صحة المدخلات ومطابقة المخرجات للكود المحلي المعمول به في منطقتك." : "You are responsible for the accuracy of inputs and for ensuring outputs comply with the building code applicable in your jurisdiction."}</p>
          <p>{isAr ? "الخدمة مقدمة كما هي. قد نعدّل الميزات أو خطط الأسعار في أي وقت مع إشعار مناسب." : "The service is provided as-is. We may change features or pricing at any time with reasonable notice."}</p>
        </div>
      </div>
    </div>
  );
}
